<template>
  <div class="super-discount-sticky-container">
    <separator class="separator" />
    <div class="padding-m">
      <slot name="content"></slot>
      <riseup-button class="margin-top-m" :action="() => this.$emit('click')" :title="buttonText" :disabled="disabled"/>
    </div>
  </div>
</template>

<script>

import BaseUI from '@riseupil/base-ui';

export default {
  name: 'StickyBottom',
  props: {
    buttonText: { type: String, require: true },
    disabled: { type: Boolean, default: false },
  },
  components: {
    RiseupButton: BaseUI.RiseupButton,
    Separator: BaseUI.Separator,
  },
};
</script>

<style lang="scss" scoped>
@import "~@riseupil/base-ui/src/scss/riseup-colors";

.super-discount-sticky-container {
  box-shadow: 0px -6px 24px 0px #20212514;
  background-color: $riseup_white;
  position: sticky;
  bottom: 0;
}

</style>
